import { InputBase, InputBaseProps } from '@mantine/core'
import { forwardRef, useImperativeHandle, useRef } from 'react'
import { IMaskInput } from 'react-imask'

interface PhoneInputRef {
  focus: () => void
  value: string
}

type DSPhoneInputProps = InputBaseProps & {
  placeholder?: string
  value?: string
  flex?: number
  onChange?: (value: string) => void
}

const DSPhoneInput = forwardRef<PhoneInputRef, DSPhoneInputProps>(
  ({ label, placeholder, value, onChange, ...props }, ref) => {
    const inputRef = useRef<HTMLInputElement | null>(null)
    const lastValueRef = useRef<string>(value || '')

    useImperativeHandle(ref, () => ({
      focus: () => inputRef.current?.focus(),
      get value() {
        return inputRef.current?.value || ''
      },
      set value(val: string) {
        if (inputRef.current) {
          inputRef.current.value = val
        }
      },
    }))

    const handleAccept = (val: string) => {
      // Only trigger onChange if the value actually changed (not just reformatted on mount)
      if (val !== lastValueRef.current) {
        lastValueRef.current = val
        onChange?.(val)
      }
    }

    return (
      <InputBase
        label={label}
        component={IMaskInput}
        mask="+1 (000) 000-0000"
        placeholder={placeholder}
        inputRef={inputRef}
        value={value}
        onAccept={handleAccept}
        {...props}
      />
    )
  },
)

DSPhoneInput.displayName = 'DSPhoneInput'

export default DSPhoneInput
